import showToaster from '../../helpers/showToaster';
import { userManagement as query, updateBanServiceHistoryStatus as mutation} from '../../lib/graphql';

export function updateBanServiceHistoryStatus(id, banStatus, userMail, userName, currentPage, searchList) {

  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation,
        variables: {
          id,
          banStatus: Number(banStatus)
        },
        fetchPolicy: 'network-only',
        refetchQueries: [{ query, variables: { currentPage, searchList } }]
      });
      if (data?.updateBanServiceHistoryStatus?.status === "success") {
        showToaster({ messageId: 'updateBanStatus', toasterType: 'success' })
      } else {
        showToaster({ messageId: 'updateBanError', toasterType: 'error' })
      }
    } catch (error) {
      showToaster({ messageId: 'updateBanWarning', toasterType: 'warning' })
      return false;
    }
    return true;
  };
}
